import React, { useState } from 'react'
import { HubCompanyEvaluatorsManagement } from 'domain/feature/hub/company/challenge/evaluators'

export const HubCompanyEvaluatorsPage = (): JSX.Element => {
  return (
    <HubCompanyEvaluatorsManagement />
  )
}
